import React from 'react'
import Manager from '../../public/components/Manager'
import PersonInfoDiv from './PersonInfoDiv'
import TeamDiv from './TeamDiv'
import DepDiv from './DepDiv'
Ext.require('Ext.Toast')


const config = ({ roles }) => {
	const tipTools = [{
		_tool: '', icon: 'info-circle', ui: 'action', tooltip: o => (
			`
			姓名: ${o['姓名']}<br>
			所在部门: ${o['所在部门']}
			`
		)
	}]

	return {
		tabs: {
			'在职人员': {
				buttons: [
				],
				export: roles.indexOf('人事专员') > -1 || roles.indexOf('权限管理员') > -1,
				exportColumns: [
					{ _text: '姓名', field: 'ActualName', width: 150 },
					{ _text: '员工编号', field: 'PersonNo', width: 150 },
					{ _date: '出生日期', field: 'Birthday', width: 150 },
					{ _text: '性别', field: 'PersonSex', width: 150 },
					{ _text: '身份证号', field: 'IDNumber', width: 150 },
					{ _text: '部门名称', field: 'Dep.ShortName', width: 150 },
					{ _date: '入职日期', field: 'EntryDate', width: 150 },
					{ _date: '转正日期', field: 'ConfirmationDate', width: 150 },
					{ _text: '职等', field: 'PositionGrade', width: 150 },
					{ _text: '联系电话', field: 'PersonMobile', width: 150 },
					{ _text: '紧急联系人关系', field: 'EmergencyContactRelationship', width: 150 },
					{ _text: '紧急联系人姓名', field: 'EmergencyContactName', width: 150 },
					{ _text: '紧急联系人电话', field: 'EmergencyContactTel', width: 150 },
					{ _text: '学历', field: '_EducationName', width: 150 },
					{ _text: '学校名称（中文）', field: '_SchoolName', width: 150 },
					{ _text: '毕业科系', field: '_FinishSchool', width: 150 },
					{ _text: '职务', field: 'PersonDuty', width: 150 },
					{ _text: '英文名', field: 'PersonNameE', width: 150 },
					{ _text: '班别', field: 'Shift', width: 150 },
				],
				columns: [
					{ _text: '姓名', field: 'ActualName', search: true, minWidth: 150/* , tools: tipTools */ },
					{ _text: '工号', field: 'PersonNo', search: true, minWidth: 150 },
					{ _text: '职务', field: 'PersonDuty', search: true, minWidth: 150 },
					{ _text: '所在部门', field: 'Dep.DepName', search: true, minWidth: 150, flex: 1, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
					{ _text: '手机号码', field: 'PersonMobile', search: true, minWidth: 150 },
					{ _text: '邮箱', field: 'PersonEmail', search: true, minWidth: 200, flex: 1, },
					{ _text: '座机', field: 'PersonOfficeTel', minWidth: 50, search: true, renderer: v => v ? v.split('-')[v.split('-').length - 1] : '' },
				],
				onDoubleTap: ({ showDetail }, data) => showDetail(props => <PersonInfoDiv {...props} id={data.id} />),
				categories: {
					onDoubleTap: (that, data, record, grid) => {
					},
					width: '330',
					expandLevel: 2,
					contextmenu: [
						//一级
						{
							_button: '添加总部', icon: 'plus',
							hidden: data => data.type != '全部' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//二级
						{
							_button: '添加公司', icon: 'plus',
							hidden: data => data.depth != 2 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//三级
						{
							_button: '添加处', icon: 'plus',
							hidden: data => data.depth != 3 || data.type != '部门' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//四级
						{
							_button: '添加部', icon: 'plus',
							hidden: data => data.depth != 4 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//五级
						{
							_button: '添加课', icon: 'plus',
							hidden: data => data.depth != 5 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//六级
						{
							_button: '添加小组', icon: 'plus',
							hidden: data => data.depth != 6 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('小组信息', props => <TeamDiv {...props} id={0} depID={data.id} onSave={that.refresh} />)
							},
						},
						//七级
						{
							_button: '添加人员', icon: 'user-plus',
							hidden: data => data.type == '全部' || data.type == '小组' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1 && (roles.indexOf('总部人事专员') == -1 || data.depth != 2),
							handler: (that, data, record, grid) => {
								that.showDetail(props => <PersonInfoDiv {...props} id={0} teamID={0} depID={data.id} />)
							},
						},
						{
							_button: '属性', icon: 'info',
							hidden: data => data.type == '全部' || data.depth == 7,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth} id={data.id} onSave={that.refresh} />)
							},
						},
						//六级
						{
							_button: '属性', icon: 'info',
							hidden: data => data.depth != 7 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('小组信息', props => <TeamDiv {...props} id={data.id} onSave={that.refresh} />)
							},
						},
					],
				},
			},
			'试用期到期预警': {
				buttons: [
				],
				export: roles.indexOf('人事专员') > -1 || roles.indexOf('权限管理员') > -1,
				exportColumns: [
					{ _text: '姓名', field: 'ActualName', width: 150 },
					{ _text: '员工编号', field: 'PersonNo', width: 150 },
					{ _date: '出生日期', field: 'Birthday', width: 150 },
					{ _text: '性别', field: 'PersonSex', width: 150 },
					{ _text: '身份证号', field: 'IDNumber', width: 150 },
					{ _text: '部门名称', field: 'Dep.ShortName', width: 150 },
					{ _date: '入职日期', field: 'EntryDate', width: 150 },
					{ _date: '转正日期', field: 'ConfirmationDate', width: 150 },
					{ _text: '职等', field: 'PositionGrade', width: 150 },
					{ _text: '联系电话', field: 'PersonMobile', width: 150 },
					{ _text: '紧急联系人关系', field: 'EmergencyContactRelationship', width: 150 },
					{ _text: '紧急联系人姓名', field: 'EmergencyContactName', width: 150 },
					{ _text: '紧急联系人电话', field: 'EmergencyContactTel', width: 150 },
					{ _text: '学历', field: '_EducationName', width: 150 },
					{ _text: '学校名称（中文）', field: '_SchoolName', width: 150 },
					{ _text: '毕业科系', field: '_FinishSchool', width: 150 },
					{ _text: '英文名', field: 'PersonNameE', width: 150 },
					{ _text: '班别', field: 'Shift', width: 150 },
				],
				columns: [
					{ _text: '姓名', field: 'ActualName', search: true, minWidth: 150/* , tools: tipTools */ },
					{ _text: '工号', field: 'PersonNo', search: true, minWidth: 150 },
					{ _text: '职务', field: 'PersonDuty', search: true, minWidth: 150 },
					{ _text: '所在部门', field: 'Dep.DepName', search: true, minWidth: 150, flex: 1, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
					{ _text: '手机号码', field: 'PersonMobile', search: true, minWidth: 150 },
					{ _text: '邮箱', field: 'PersonEmail', search: true, minWidth: 200, flex: 1, },
					{ _text: '座机', field: 'PersonOfficeTel', minWidth: 50, search: true, renderer: v => v ? v.split('-')[v.split('-').length - 1] : '' },
				],
				onDoubleTap: ({ showDetail }, data) => showDetail(props => <PersonInfoDiv {...props} id={data.id} />),
				categories: {
					onDoubleTap: (that, data, record, grid) => {
					},
					width: '330',
					expandLevel: 2,
					contextmenu: [
						//一级
						{
							_button: '添加总部', icon: 'plus',
							hidden: data => data.type != '全部' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//二级
						{
							_button: '添加公司', icon: 'plus',
							hidden: data => data.depth != 2 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//三级
						{
							_button: '添加处', icon: 'plus',
							hidden: data => data.depth != 3 || data.type != '部门' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//四级
						{
							_button: '添加部', icon: 'plus',
							hidden: data => data.depth != 4 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//五级
						{
							_button: '添加课', icon: 'plus',
							hidden: data => data.depth != 5 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//六级
						{
							_button: '添加小组', icon: 'plus',
							hidden: data => data.depth != 6 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('小组信息', props => <TeamDiv {...props} id={0} depID={data.id} onSave={that.refresh} />)
							},
						},
						//七级
						{
							_button: '添加人员', icon: 'user-plus',
							hidden: data => data.type == '全部' || data.type == '小组' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1 && (roles.indexOf('总部人事专员') == -1 || data.depth != 2),
							handler: (that, data, record, grid) => {
								that.showDetail(props => <PersonInfoDiv {...props} id={0} teamID={0} depID={data.id} />)
							},
						},
						{
							_button: '属性', icon: 'info',
							hidden: data => data.type == '全部' || data.depth == 7,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth} id={data.id} onSave={that.refresh} />)
							},
						},
						//六级
						{
							_button: '属性', icon: 'info',
							hidden: data => data.depth != 7 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('小组信息', props => <TeamDiv {...props} id={data.id} onSave={that.refresh} />)
							},
						},
					],
				},
			},
			'劳动合同到期预警': {
				buttons: [
				],
				export: roles.indexOf('人事专员') > -1 || roles.indexOf('权限管理员') > -1,
				exportColumns: [
					{ _text: '姓名', field: 'ActualName', width: 150 },
					{ _text: '员工编号', field: 'PersonNo', width: 150 },
					{ _date: '出生日期', field: 'Birthday', width: 150 },
					{ _text: '性别', field: 'PersonSex', width: 150 },
					{ _text: '身份证号', field: 'IDNumber', width: 150 },
					{ _text: '部门名称', field: 'Dep.ShortName', width: 150 },
					{ _date: '入职日期', field: 'EntryDate', width: 150 },
					{ _date: '转正日期', field: 'ConfirmationDate', width: 150 },
					{ _text: '职等', field: 'PositionGrade', width: 150 },
					{ _text: '联系电话', field: 'PersonMobile', width: 150 },
					{ _text: '紧急联系人关系', field: 'EmergencyContactRelationship', width: 150 },
					{ _text: '紧急联系人姓名', field: 'EmergencyContactName', width: 150 },
					{ _text: '紧急联系人电话', field: 'EmergencyContactTel', width: 150 },
					{ _text: '学历', field: '_EducationName', width: 150 },
					{ _text: '学校名称（中文）', field: '_SchoolName', width: 150 },
					{ _text: '毕业科系', field: '_FinishSchool', width: 150 },
					{ _text: '英文名', field: 'PersonNameE', width: 150 },
					{ _text: '班别', field: 'Shift', width: 150 },
				],
				columns: [
					{ _text: '姓名', field: 'ActualName', search: true, minWidth: 150/* , tools: tipTools */ },
					{ _text: '工号', field: 'PersonNo', search: true, minWidth: 150 },
					{ _text: '职务', field: 'PersonDuty', search: true, minWidth: 150 },
					{ _text: '所在部门', field: 'Dep.DepName', search: true, minWidth: 150, flex: 1, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
					{ _text: '手机号码', field: 'PersonMobile', search: true, minWidth: 150 },
					{ _text: '邮箱', field: 'PersonEmail', search: true, minWidth: 200, flex: 1, },
					{ _text: '座机', field: 'PersonOfficeTel', minWidth: 50, search: true, renderer: v => v ? v.split('-')[v.split('-').length - 1] : '' },
				],
				onDoubleTap: ({ showDetail }, data) => showDetail(props => <PersonInfoDiv {...props} id={data.id} />),
				categories: {
					onDoubleTap: (that, data, record, grid) => {
					},
					width: '330',
					expandLevel: 2,
					contextmenu: [
						//一级
						{
							_button: '添加总部', icon: 'plus',
							hidden: data => data.type != '全部' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//二级
						{
							_button: '添加公司', icon: 'plus',
							hidden: data => data.depth != 2 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//三级
						{
							_button: '添加处', icon: 'plus',
							hidden: data => data.depth != 3 || data.type != '部门' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//四级
						{
							_button: '添加部', icon: 'plus',
							hidden: data => data.depth != 4 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//五级
						{
							_button: '添加课', icon: 'plus',
							hidden: data => data.depth != 5 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//六级
						{
							_button: '添加小组', icon: 'plus',
							hidden: data => data.depth != 6 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('小组信息', props => <TeamDiv {...props} id={0} depID={data.id} onSave={that.refresh} />)
							},
						},
						//七级
						{
							_button: '添加人员', icon: 'user-plus',
							hidden: data => data.type == '全部' || data.type == '小组' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1 && (roles.indexOf('总部人事专员') == -1 || data.depth != 2),
							handler: (that, data, record, grid) => {
								that.showDetail(props => <PersonInfoDiv {...props} id={0} teamID={0} depID={data.id} />)
							},
						},
						{
							_button: '属性', icon: 'info',
							hidden: data => data.type == '全部' || data.depth == 7,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth} id={data.id} onSave={that.refresh} />)
							},
						},
						//六级
						{
							_button: '属性', icon: 'info',
							hidden: data => data.depth != 7 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('小组信息', props => <TeamDiv {...props} id={data.id} onSave={that.refresh} />)
							},
						},
					],
				},
			},
			'离职人员': {
				buttons: [
				],
				export: roles.indexOf('人事专员') > -1 || roles.indexOf('权限管理员') > -1,
				exportColumns: [
					{ _text: '姓名', field: 'ActualName', width: 150 },
					{ _text: '员工编号', field: 'PersonNo', width: 150 },
					{ _date: '出生日期', field: 'Birthday', width: 150 },
					{ _text: '性别', field: 'PersonSex', width: 150 },
					{ _text: '身份证号', field: 'IDNumber', width: 150 },
					{ _text: '部门名称', field: 'Dep.ShortName', width: 150 },
					{ _date: '入职日期', field: 'EntryDate', width: 150 },
					{ _date: '转正日期', field: 'ConfirmationDate', width: 150 },
					{ _text: '职等', field: 'PositionGrade', width: 150 },
					{ _text: '联系电话', field: 'PersonMobile', width: 150 },
					{ _text: '紧急联系人关系', field: 'EmergencyContactRelationship', width: 150 },
					{ _text: '紧急联系人姓名', field: 'EmergencyContactName', width: 150 },
					{ _text: '紧急联系人电话', field: 'EmergencyContactTel', width: 150 },
					{ _text: '学历', field: '_EducationName', width: 150 },
					{ _text: '学校名称（中文）', field: '_SchoolName', width: 150 },
					{ _text: '毕业科系', field: '_FinishSchool', width: 150 },
					{ _text: '英文名', field: 'PersonNameE', width: 150 },
					{ _text: '班别', field: 'Shift', width: 150 },
				],
				columns: [
					{ _text: '姓名', field: 'ActualName', search: true, minWidth: 150/* , tools: tipTools */ },
					{ _text: '工号', field: 'PersonNo', search: true, minWidth: 150 },
					{ _text: '职务', field: 'PersonDuty', search: true, minWidth: 150 },
					{ _text: '所在部门', field: 'Dep.DepName', search: true, minWidth: 150, flex: 1, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
					{ _text: '手机号码', field: 'PersonMobile', search: true, minWidth: 150 },
					{ _text: '邮箱', field: 'PersonEmail', search: true, minWidth: 200, flex: 1, },
					{ _text: '座机', field: 'PersonOfficeTel', minWidth: 50, search: true, renderer: v => v ? v.split('-')[v.split('-').length - 1] : '' },
				],
				onDoubleTap: ({ showDetail }, data) => showDetail(props => <PersonInfoDiv {...props} id={data.id} />),
				categories: {
					onDoubleTap: (that, data, record, grid) => {
					},
					width: '330',
					expandLevel: 2,
					contextmenu: [
						//一级
						{
							_button: '添加总部', icon: 'plus',
							hidden: data => data.type != '全部' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//二级
						{
							_button: '添加公司', icon: 'plus',
							hidden: data => data.depth != 2 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//三级
						{
							_button: '添加处', icon: 'plus',
							hidden: data => data.depth != 3 || data.type != '部门' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//四级
						{
							_button: '添加部', icon: 'plus',
							hidden: data => data.depth != 4 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//五级
						{
							_button: '添加课', icon: 'plus',
							hidden: data => data.depth != 5 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth + 1} fatherID={data.id} id={0} onSave={that.refresh} />)
							},
						},
						//六级
						{
							_button: '添加小组', icon: 'plus',
							hidden: data => data.depth != 6 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('小组信息', props => <TeamDiv {...props} id={0} depID={data.id} onSave={that.refresh} />)
							},
						},
						//七级
						{
							_button: '添加人员', icon: 'user-plus',
							hidden: data => data.type == '全部' || data.type == '小组' || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1 && (roles.indexOf('总部人事专员') == -1 || data.depth != 2),
							handler: (that, data, record, grid) => {
								that.showDetail(props => <PersonInfoDiv {...props} id={0} teamID={0} depID={data.id} />)
							},
						},
						{
							_button: '属性', icon: 'info',
							hidden: data => data.type == '全部' || data.depth == 7,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('部门设置', props => <DepDiv {...props} depth={data.depth} id={data.id} onSave={that.refresh} />)
							},
						},
						//六级
						{
							_button: '属性', icon: 'info',
							hidden: data => data.depth != 7 || roles.indexOf('权限管理员') == -1 && roles.indexOf('总经理') == -1 && roles.indexOf('人事专员') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('小组信息', props => <TeamDiv {...props} id={data.id} onSave={that.refresh} />)
							},
						},
					],
				},
			},
		},
	}
}

export default props => <Manager {...props} config={config} />